// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagsFilledSvg from "@fishx/icons-svg/es/asn/TagsFilled";
import FishxIcon from '../components/FishxIcon';

var TagsFilled = function TagsFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagsFilledSvg
  }));
};

TagsFilled.displayName = 'TagsFilled';
export default React.forwardRef(TagsFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TagsFilled.js
// module id = 4235
// module chunks = 0